const snippets = {
  login: {
    headline: 'Melde dich mit deinem Appsite Admin Account an',
    button: 'Login',
    helpMessage: 'Du benötigst Hilfe?',
  },
  compare: {
    previous: 'Vorheriger Zeitraum',
    current: 'Aktueller Zeitraum',
  },
  customerOverview: {
    pageTitle: 'Kundenauswahl',
    fequentlyUsed: 'Häufig verwendet',
    available: 'Verfügbare Kunden',
    searchLabel: 'Suche',
    notice: 'Im Appsiteadmin müssen die Statistken aktiviert werden, damit ein Club in dieser Liste erscheint',
  },
  customerDetail: {
    chartTitle: 'Gesamt Übersicht',
    staticCards: {
      active: 'aktive Mitglieder',
      cancelations: 'Kündigungen',
      activations: 'Zugänge',
      tooltips: {
        storno: `<strong class='text-gray-700 font-semibold text-xl'>Stornos</strong> <br><br>
        Hauptabos werden am Tag des Vertragsabschlusses als Zugang (s.o.) gewertet. Bis zur Stornierung ist es ein normales Hauptabo.
         Die Stornierung führt zu einem Abgang am Vertragsabschluss-Datum, d.h. am Vertragsabschluss-Datum wird sowohl ein Zugang als auch ein Abgang gewertet. Damit fällt ein storniertes Hauptabo aus dem Bestand “Aktive Mitglieder“.
</br></br>
Die Stornierung ist gedacht um Eingabefehler, d.h. sehr zeitnah zu Erstellung eines Abos, zu korrigieren. Wird die Stornierung rückwirkend angewendet, so hat das rückwirkend Auswirkungen auf die Anzahl “Aktive Mitglieder“.`,
        active: 'Mitglieder mit aktivem Haputabo zum Ende des eingestellen Zeitraums.',
        activations: `
          Ein Zugang entsteht an dem Tag des Vertragsabschlusses eines Hauptabos.
          Hat das Mitglied mindestens 1 weiteres Hauptabo, welches ein früheres Vertragsabschluss-Datum hat,
          so ist das frühere Vertragsabschluss-Datum aus diesen Hauptabos für den Zugang relevant.
          Mit dem Zugang der Mitgliedschaft erhöht sich der Bestand "Aktive Mitglieder".`,
        cancelations: `
          Ein Abgang entsteht durch ein Hauptabo welches zum Vortag gekündigt wurde (KündigungZum).
          Hat das Mitglied mindestens 1 weiteres Hauptabo, welches sich anschließt oder überlappt,
          so ist das späteste KündigungZum-Datum aus diesen Hauptabos für den Abgang relevant.
        `,
        terminations: `
          <strong class="text-gray-700 font-semibold text-xl">Kündigungen</strong> <br><br>
          Eine Kündigung entsteht durch ein Hauptabo welches gekündigt wurde (KündigungAm).
Es zählt das Datum, an welchem die Kündigung eingeht.
Eine Kündigung wirkt sich nicht unmittelbar auf den Bestand aus, sondern zeigt die aktuelle Dynamik. `,
        leaves: 'In Kraft getrentene Kündigungen vom Hauptabo im eingestellten Zeitraum.',
        leavesInTesting:
          'In Kraft getretene Kündigungen vom Hauptabo im eingestellten Zeitraum, die noch in det Testphase erfolgten.',
        addonSum: 'Summe aller aktiven ADD-ONs',
        addonUser: 'Anzahl der ADD-ONs pro Mitglied',
        addonActivations: `
          <strong class="text-gray-700 font-semibold text-xl">ADD-ONs / Zugang</strong> <br><br>
          Zugänge ADD-ONs / Zugänge Mitglieder.
        `,
      },
    },
    clubOverviewHeadline: 'Clubs im Detail',
    moreInfo: 'Details',
  },
  range: {
    week: '1W',
    month: '1M',
    year: '1J',
    custom: 'Individuell',
  },
  addonDetail: {
    headline: 'Aktive ADD-ONs',
    hidden: 'gefiltert',
    showHideHeadline: 'ADD-Ons ein-/ausblenden',
    costPerMonth: 'Einnahmen / ',
  },
  daypassDetail: {
    headline: 'Tageskarten',
    sold: 'Verkaufte Tageskarten',
    perBuyer: 'Tageskarten / Käufer',
    soldShort: 'Verkäufe',
    chartTitle: 'Gebuchte Tage im Zeitraum',
    perTemplate: 'Verkäufe je Tageskarte',
    share: 'Anteil',
    tooltip: `<strong class='text-gray-700 font-semibold text-xl'>Tageskarten</strong> <br><br>
      <strong>Verkaufte Tageskarten:</strong> im gewählten Zeitraum abgeschlossene Käufe – ausgestellte,
      nicht erstattete Tageskarten. Der Prozentwert vergleicht mit dem Vergleichszeitraum.
      </br></br>
      <strong>Tageskarten / Käufer:</strong> verkaufte Tageskarten geteilt durch die Zahl
      unterschiedlicher Käufer, erkannt an der E-Mail-Adresse.
      </br></br>
      <strong>Gebuchte Tage im Zeitraum:</strong> Tageskarten nach dem Tag, für den sie gelten –
      unabhängig davon, wann sie gekauft wurden.`,
  },
  members: 'Mitglieder',
  cancellations: 'Kündigungseingänge',
  activations: 'Zugänge',
  email: 'E-Mail',
  password: 'Passwort',
};

export default snippets;
